import { render, staticRenderFns } from "./NiveisAcessoRead.vue?vue&type=template&id=00ba9aba&"
import script from "./NiveisAcessoRead.vue?vue&type=script&lang=js&"
export * from "./NiveisAcessoRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports